export const generalTaskManagerTableData = {
    keys: [
        "task_name",
        "task_type",
        "user_name",
        "client_name",
        "project_name",
        "status_name",
        "created_at",
        "date_done",
        "duration",
        "cancel_requested_at",
        "cancel_requested_by_name",
        "current_attempt",
        "max_attempts",
        "updated_at"
    ],
    config: {
        task_name: {
            isVisible: true,
            label: "Task Name",
            class: "width-180px",
            searchKey: "fca_task_manager.task_name",
            filterIdKey: "task_name",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: true,
            getListTable: "task_name",
            commonSearchKey: "task_name",
            commonSearchObjectKey: "name"
        },
        task_type: {
            isVisible: true,
            label: "Task Type",
            class: "width-160px",
            searchKey: "fca_task_manager.task_type",
            filterIdKey: "task_type",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: true,
            getListTable: "task_type",
            commonSearchKey: "task_type",
            commonSearchObjectKey: "name"
        },
        user_name: {
            isVisible: true,
            label: "User Name",
            class: "width-160px",
            searchKey: "users.name",
            filterIdKey: "user",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: true,
            getListTable: "user",
            commonSearchKey: "user_name",
            commonSearchObjectKey: "name"
        },
        client_name: {
            isVisible: true,
            label: "Client Name",
            class: "width-160px",
            searchKey: "clients.name",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: true,
            getListTable: "clients.name",
            commonSearchKey: "client_name",
            commonSearchObjectKey: "name"
        },
        project_name: {
            isVisible: true,
            label: "Project Name",
            class: "width-160px",
            searchKey: "projects.name",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: true,
            getListTable: "projects.name",
            commonSearchKey: "project_name",
            commonSearchObjectKey: "name"
        },
        result: {
            isVisible: true,
            label: "Result",
            class: "width-160px",
            searchKey: "fca_task_manager.result",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "result",
            commonSearchKey: "result",
            commonSearchObjectKey: "name"
        },
        status_name: {
            isVisible: true,
            label: "Status",
            class: "width-160px",
            searchKey: "fca_task_manager.status",
            filterIdKey: "status",
            type: "string",
            hasWildCardSearch: false,
            hasCommonSearch: true,
            getListTable: "status",
            commonSearchKey: "status_name",
            commonSearchObjectKey: "name",
            commonFilterId: "status"
        },
        created_at: {
            isVisible: true,
            label: "Initiated Time",
            class: "width-180px",
            searchKey: "fca_task_manager.created_at",
            type: "date",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "created_at",
            commonSearchKey: "created_at",
            commonSearchObjectKey: "created_at"
        },
        date_done: {
            isVisible: true,
            label: "Completed Time",
            class: "width-180px",
            searchKey: "fca_task_manager.date_done",
            type: "date",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "date_done",
            commonSearchKey: "date_done",
            commonSearchObjectKey: "date_done"
        },
        duration: {
            isVisible: true,
            label: "Time Taken",
            class: "width-160px",
            searchKey: "fca_task_manager.duration",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "duration",
            commonSearchKey: "duration",
            commonSearchObjectKey: "duration"
        },
        cancel_requested_at: {
            isVisible: true,
            label: "Cancel Requested Time",
            class: "width-180px",
            searchKey: "fca_task_manager.cancel_requested_at",
            type: "date",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "cancel_requested_at",
            commonSearchKey: "cancel_requested_at",
            commonSearchObjectKey: "cancel_requested_at"
        },
        cancel_requested_by_name: {
            isVisible: true,
            label: "Cancel Requested By",
            class: "width-160px",
            searchKey: "fca_task_manager.cancel_requested_by",
            filterIdKey: "cancel_requested_by",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: true,
            getListTable: "cancel_requested_by_name",
            commonSearchKey: "cancel_requested_by_name"
        },
        current_attempt: {
            isVisible: true,
            label: "Current Attempt",
            class: "width-140px",
            searchKey: "fca_task_manager.current_attempt",
            type: "number",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "current_attempt",
            commonSearchKey: "current_attempt",
            commonSearchObjectKey: "current_attempt"
        },
        max_attempts: {
            isVisible: true,
            label: "Max Attempts",
            class: "width-140px",
            searchKey: "fca_task_manager.max_attempts",
            type: "number",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "max_attempts",
            commonSearchKey: "max_attempts",
            commonSearchObjectKey: "max_attempts"
        },
        updated_at: {
            isVisible: true,
            label: "Updated At",
            class: "width-180px",
            searchKey: "fca_task_manager.updated_at",
            type: "date",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "updated_at",
            commonSearchKey: "updated_at",
            commonSearchObjectKey: "updated_at"
        }
    }
};
export const generalTaskStatus = [
    { value: "PENDING", class: "pending-task", color: "#e61607" },
    { value: "QUEUED", class: "queued-task", color: "#FFA500" },
    { value: "IN PROGRESS", class: "running-task", color: "#006EFF" },
    { value: "COMPLETED", class: "completed-task", color: "#04B934" },
    { value: "FAILED", class: "pending-task", color: "#e61607" },
    { value: "CANCELLED", class: "pending-task", color: "#e61607" },
    { value: "STUCK", class: "queued-task", color: "#FF8C00" }
];

export const GET_GENERAL_TASK_MANAGER_LIST_REQUEST = "GET_GENERAL_TASK_MANAGER_LIST_REQUEST";
export const GET_GENERAL_TASK_MANAGER_LIST_SUCCESS = "GET_GENERAL_TASK_MANAGER_LIST_SUCCESS";
export const GET_GENERAL_TASK_MANAGER_LIST_FAILURE = "GET_GENERAL_TASK_MANAGER_LIST_FAILURE";

export const GET_GENERAL_TASK_MANAGER_TABLE_FILTER_REQUEST = "GET_GENERAL_TASK_MANAGER_TABLE_FILTER_REQUEST";
export const GET_GENERAL_TASK_MANAGER_TABLE_FILTER_SUCCESS = "GET_GENERAL_TASK_MANAGER_TABLE_FILTER_SUCCESS";
export const GET_GENERAL_TASK_MANAGER_TABLE_FILTER_FAILURE = "GET_GENERAL_TASK_MANAGER_TABLE_FILTER_FAILURE";

export const DELETE_GENERAL_TASK_MANAGER_BY_ID_REQUEST = "DELETE_GENERAL_TASK_MANAGER_BY_ID_REQUEST";
export const DELETE_GENERAL_TASK_MANAGER_BY_ID_SUCCESS = "DELETE_GENERAL_TASK_MANAGER_BY_ID_SUCCESS";
export const DELETE_GENERAL_TASK_MANAGER_BY_ID_FAILURE = "DELETE_GENERAL_TASK_MANAGER_BY_ID_FAILURE";

export const CANCEL_GENERAL_TASK_MANAGER_BY_ID_REQUEST = "CANCEL_GENERAL_TASK_MANAGER_BY_ID_REQUEST";
export const CANCEL_GENERAL_TASK_MANAGER_BY_ID_SUCCESS = "CANCEL_GENERAL_TASK_MANAGER_BY_ID_SUCCESS";
export const CANCEL_GENERAL_TASK_MANAGER_BY_ID_FAILURE = "CANCEL_GENERAL_TASK_MANAGER_BY_ID_FAILURE";

export const UPDATE_TASK_MANAGER_ENTITY_PARAMS_SUCCESS = "UPDATE_TASK_MANAGER_ENTITY_PARAMS_SUCCESS";
export const UPDATE_TASK_MANAGER_ENTITY_PARAMS_FAILURE = "UPDATE_TASK_MANAGER_ENTITY_PARAMS_FAILURE";
